import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: localStorage.getItem("language") || "de",

    returnEmptyString: true,
    fallbackLng: "de",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: { 
      useSuspense: false
    },

    // if key isn't found return blank. (at the beginning keys aren't found, because they will load later)
    parseMissingKeyHandler: (key) => ""
  });

export default i18n;